/**
 * Joins query parameters. It excludes all parameters that are `falsish` (e.g. Empty string, undefined, null).
 * A query parameter can also be a list of query parameters, if that is the case and the parameter begins with `?`
 * then the `?` symbol will be removed.
 *
 * @param params - A list of query parameters.
 * @returns Result of joined query parameters with `?` in the beginning.
 */
const joinQueryParams = (...params) => {
    const cleanParams = params
        .filter((p) => Boolean(p))
        .map((p) => (p[0] === '?' ? p.substr(1) : p));
    if (cleanParams.length > 0) {
        return `?${cleanParams.join('&')}`;
    }
    return '';
};
export default joinQueryParams;
//# sourceMappingURL=joinQueryParams.js.map